import type {
  DeleteOpenPositionMutationResult,
  DeleteOpenPositionMutationVariables,
  OpenPositionsFragment,
} from '../../graphql';
import { DeleteOpenPositionDocument } from '../../graphql';
import { apolloClient } from '../../lib/init-apollo';
import { toast } from 'react-toastify';

export async function handleDeleteOpenPosition(
  openPosition: OpenPositionsFragment,
) {
  try {
    const result = await apolloClient?.mutate<
      DeleteOpenPositionMutationResult['data'],
      DeleteOpenPositionMutationVariables
    >({
      mutation: DeleteOpenPositionDocument,
      variables: {
        openPositionId: openPosition.id,
      },
    });
    if (result?.errors?.length) {
      toast.error(
        `Error deleting open position: ${result.errors
          .map((e) => e.toString())
          .join('\n')}`,
      );
      console.error(`Error deleting open position:`, result.errors);
    }
  } catch (e) {
    toast.error(`Error deleting open position: ${e.toString()}`);
    console.error(`Error deleting open position:`, e);
  }
}
